import {de_DE_formal} from '@App/locales/de_DE-formal';
import {de_DE_globalTranslations} from "@App/locales/de_DE-globalTranslations";

export const controlExpert = {
    ...de_DE_formal,
    ...{
        translation: {
            ...de_DE_globalTranslations.translation,
            hero: {
                'title': 'Willkommen bei der Werkstatt-Buchung von {{organization}}',
                'subtitle': null,
            },
            welcomeModal: {
                'title': 'Sie verlassen nun die Seite von {{organization}}',
                'text': 'Bitte beachten Sie, dass Sie sich auf einer Website befinden, für deren Inhalt {{organization}} nicht verantwortlich ist und die Datenschutzbestimmungen von {{organization}} keine Anwendung finden.',
            },
            hint: {
                'text': 'Alle gezeigten Werkstätten sind von {{organization}} freigegeben.',
            },
            contactForm: {
                'message-label-required': 'Was möchten Sie der Werkstatt mitteilen?',
                'message-label': 'Was möchten Sie der Werkstatt mitteilen?',
                placeholders: {
                    'message': 'Bitte beschreiben Sie den nötigen Service (optional)',
                    'message-required': 'Bitte beschreiben Sie den nötigen Service',
                },
            },
        },
    }
}
